export enum PhoneNumberType {
  Home = 0,
  Business = 1,
  Mobile = 2,
}
